export enum LineModifiersMethodCodes {
  PriceOverride = 'PriceOverride',
  Promotion = 'Promotion',
  Return = 'Return',
  RequiredPrice = 'RequiredPrice',
  VerifyPrice = 'VerifyPrice',
  ReturnWithDiscount = 'ReturnWithDiscount',
  ManualPrice = 'ManualPrice',
  PriceVerify = 'PriceVerify',
  ResetPrice = 'ResetPrice',
}
